// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1dXqV","clinicsSelect":"TableHeading_clinicsSelect__3OevK"};